import React from "react";

import { Stack, Typography, TypographyVariant } from "@mui/material";

type HelpTextProps = {
  text: string;
  subtext?: string;
  variant?: TypographyVariant;
  spacing?: number;
};

const TitleText: React.FC<HelpTextProps> = ({
  text,
  subtext,
  variant = "body1",
  spacing = 1
}) => {
  return (
    <Stack spacing={spacing}>
      <Typography variant={variant}>{text}</Typography>
      {subtext && (
        <Typography variant="caption" color="textSecondary">{subtext}</Typography>
      )}
    </Stack>
  );
};

export default TitleText;
